export default {
  cake: {
    56: '0xaAdFf17d56d80312b392Ced903f3E8dBE5c3ece7',
    97: '0x482AAE2B58De0A684c3c6B192ED66dF348801A3c',
  },
  rbs: {
    56: '0xaAdFf17d56d80312b392Ced903f3E8dBE5c3ece7',
    97: '0x482AAE2B58De0A684c3c6B192ED66dF348801A3c',
  },
  masterChef: {
    56: '0x5865C60C05C28C597b3CEB6a84809251101E5204',
    97: '0xec1ba003E6Af1A31efb9288C8425FcE821b47c19',
  },

  lockedsale:{
    56:'0xF55E37BE45FDFFb7A7A525E0B40d2a1B3fF1faA8',
    97:'0xa2f3B8935836cf6C6452Dd20D7EdCEC83C39ad4e'
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7',
  },
  btcb: {
    56: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    97: '0x6ce8dA28E2f864420840cF74474eFf5fD80E65B8',
  },
  eth: {
    56: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    97: '0xebB6891b622c3938EbF5FDec3FCF0c697f8Ae4E5',
  },

  usdt: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '',
  },
  moon: {
    56: '0xE8c93310af068aa50bd7bF0ebFa459Df2a02ceba',
    97: '',
  },
  bblurt: {
    56: '0xb0458283033e5a3f7867f409477f53754b667dcc',
    97: '',
  },
  bsteem: {
    56: '0x382d36e85178f2d3fd84e336d4e1d442fce78e8e',
    97: '',
  },
  ada: {
    56: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
    97: '',
  },
  krwp: {
    56: '0xB9Dd513420D68Ac4CCf65cBcaA8cc7bd539713ca',
    97: '',
  },
  bsct: {
    56: '0xE920575CEcE01e5D9A7AB23d1a4FD15d8CF3Fe75',
    97: '',
  },
  rini: {
    56: '0x844b1b28b0fda8075ea8eb99c46339398ded1673',
    97: '',
  },
  dot: {
    56: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
    97: '',
  },
   cake1: {
    56: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
    97: '',
  },

  // delegate farm kontratları
  delegate : {
    56 : '0xaf0400156c48672c5eec011114209fe05e3e7c28',
    97 : '0x162F9053eF2d2DCE5032d530e0863AE184B9056d'
  },
    // autoFarm farm kontratları
    cakeVault : {
      56 : '0x868f2f0c1B90ed1674f23bad495DEEa6C1Fce4e9',
      97 : '0x162F9053eF2d2DCE5032d530e0863AE184B9056d'
    }
}
